<template>
    <component :is="template">
        <v-container>
            <div class="contents-area">
                <div class="contents-area__inner mx-auto" style="max-width:800px">
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">상품권 구매하기</h2>
                        <div class="mt-4px mt-lg-8px font-size-14 font-size-md-16 grey--text text--garken-3">
                            PG 결제를 통해 나누리 캐시 교환권을 구매하실 수 있습니다.
                        </div>
                    </div>

                    <template v-if="!order._id"> </template>
                    <template v-else-if="method === 'vaccount'">
                        <v-card class="my-20px my-lg-40px mx-auto" max-width="480" color="transparent" elevation="0">
                            <v-card-title class="justify-center"> 주문이 완료되었습니다. </v-card-title>
                            <v-card-text class="pb-0 text-center">
                                <p>아래 가상계좌에 출금계좌를 통해 해당 금액을 입금해주세요.</p>
                            </v-card-text>
                        </v-card>

                        <nshop-order-view-table v-bind="{ value: order }" class="my-20px my-lg-40px mx-auto" style="max-width:480px" />
                    </template>
                    <template v-else-if="method === 'openbank'">
                        <v-card v-if="canceled" class="my-20px my-lg-40px mx-auto" max-width="480" color="transparent" elevation="0">
                            <v-card-title class="justify-center"> 취소된 주문입니다. </v-card-title>
                            <v-card-text class="pb-0 text-center"> 이 화면에서는 자동충전을 할 수 없습니다. </v-card-text>
                        </v-card>
                        <v-card v-else class="my-20px my-lg-40px mx-auto" max-width="480" color="transparent" elevation="0">
                            <v-card-title class="justify-center"> 결제가 완료되었습니다. </v-card-title>
                            <v-card-text class="pb-0 text-center">
                                <template v-if="issued">
                                    상품권이 발급되어<br />
                                    본인의 전화번호로 전송되었습니다.<br />
                                    휴대폰 문자를 확인해주세요.
                                </template>
                                <template v-else> 발급을 확인하고 있습니다. 잠시만 기다려주세요…<br /><v-progress-circular indeterminate size="20" width="2" class="mt-2" /> </template>
                            </v-card-text>
                        </v-card>

                        <nshop-order-view-table v-bind="{ value: order }" class="my-20px my-lg-40px mx-auto" style="max-width:480px" />

                        <div v-if="issued" class="mx-auto mb-20px mb-lg-40px" style="max-width:480px">
                            <v-btn x-large block color="primary" @click="gain"> 충전하기 </v-btn>
                        </div>
                    </template>
                    <template v-else-if="true">
                        <v-card class="my-20px my-lg-40px" color="transparent" elevation="0">
                            <v-card-title class="justify-center"> 결제가 완료되었습니다. </v-card-title>
                            <v-card-text class="text-center">
                                확인된 상품권은 1~5분 내로<br />
                                본인의 전화번호로 전송됩니다.<br />
                                휴대폰 문자를 확인해주세요.
                            </v-card-text>
                        </v-card>
                    </template>

                    <div class="mx-auto" style="max-width:480px">
                        <v-row class="ma-n1">
                            <v-col class="pa-1">
                                <v-btn x-large block @click="exit"> 홈으로 </v-btn>
                            </v-col>
                            <v-col class="pa-1">
                                <v-btn x-large block color="primary" @click="more"> 추가 구매하기 </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
        </v-container>
        <common-loader v-bind="{ loading }" />
        <common-message-dialog ref="messageDialog" />
    </component>
</template>

<script>
import api from "@/api";
import { initNshopOrder } from "@/store/nshop";

import CommonLoader from "@/components/common/common-loader.vue";
import CommonMessageDialog from "@/components/common/common-message-dialog.vue";
import NshopOrderViewTable from "@/components/client/nshop/order/nshop-order-view-table.vue";

export default {
    components: {
        CommonLoader,
        CommonMessageDialog,
        NshopOrderViewTable,
    },
    data: () => ({
        order: initNshopOrder(),

        loading: false,
        polling: false,
    }),
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        _order() {
            return this.$route?.query?._order;
        },
        method() {
            return this.order.payment.method;
        },
        issued() {
            return ["ISSUE_DONE", "PHONE_SENT", "ORDER_USED", "ORDER_DONE"].includes(this.order?.state);
        },
        // 취소완료(결제취소·취소표기)·주문취소 주문: 발급 확인 로딩 대신 취소 안내를 보인다. (폴링은 이 상태에서 멈춘다)
        canceled() {
            return ["ORDER_CANCEL", "ORDER_STOP"].includes(this.order?.state);
        },
    },
    methods: {
        more() {
            this.$router.go(-1);
        },
        exit() {
            this.$router.push("/");
        },
        gain() {
            this.$router.push({ path: "/purchase/gain", query: { _order: this.order._id } });
        },
        async fetchOrder(_id) {
            let { order } = await api.v1.me.nshop.orders.get({ _id });
            if (order && order._id == this._order) this.order = initNshopOrder(order);
        },
        // 오픈뱅킹: 결제 직후 발급(doProcess)이 마무리될 때까지 잠깐 폴링한다. (보통 즉시 완료)
        async pollUntilIssued(_id) {
            const terminal = ["ISSUE_DONE", "PHONE_SENT", "ORDER_USED", "ORDER_DONE", "ORDER_STOP", "ORDER_CANCEL"];

            for (let i = 0; i < 15; i++) {
                if (this._order != _id) return;
                if (terminal.includes(this.order?.state)) return;

                await new Promise((resolve) => setTimeout(resolve, 2000));

                if (this._order != _id) return;
                await this.fetchOrder(_id);
            }
        },
        // messageDialog 는 비동기 테마 컴포넌트(<component :is>) 슬롯 안에 있어
        // mounted 시점엔 아직 렌더되지 않았을 수 있다. ref 가 잡힐 때까지 대기 후 진행한다.
        waitMessageDialog() {
            return new Promise((resolve) => {
                const timer = setInterval(() => {
                    if (this.$refs.messageDialog) {
                        clearInterval(timer);
                        resolve();
                    }
                }, 50);
            });
        },
        async init() {
            if (!this.$store.state.payload?._user) {
                await this.waitMessageDialog();
                this.$refs.messageDialog.open("로그인 후 사용하실 수 있는 기능입니다.", () => {
                    this.$router.replace(`/login?to=/purchase/done?_order=${this._order}`);
                });
                return;
            }

            let _id = this._order;
            if (!_id) return;

            this.loading = true;
            try {
                await this.fetchOrder(_id);
            } catch (error) {
                console.error(error);
            }
            this.loading = false;

            if (this.order?.payment?.method === "openbank" && !this.issued) {
                this.polling = true;
                try {
                    await this.pollUntilIssued(_id);
                } catch (error) {
                    console.error(error);
                }
                this.polling = false;
            }
        },
    },
    watch: {
        _order() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>
